import React from "react";
import { Check, CreditCard, Smartphone } from "lucide-react";
import Tilt from "./template/view.tilt";
import Reveal from "./template/view.reveal";

// Keep in sync with PLANS in the API (entity/Billing.py).
const PLANS = [
    {
        name: "Gratuit", price: "0", period: "pour toujours", cta: "Commencer",
        items: ["Prise de rendez-vous", "Pharmacies et labos à proximité", "Rappels de traitement", "Suivi cycle et grossesse", "Jusqu'à 15 documents médicaux"],
    },
    {
        name: "Premium", price: "2 000", period: "FCFA / mois", cta: "Essayer 3 mois gratuits", featured: true,
        items: ["Tout le plan Gratuit", "Dossier médical illimité", "Médecins : téléconsultations illimitées", "Vous soutenez l'accès aux soins au Burkina Faso"],
    },
    {
        name: "Premium annuel", price: "20 000", period: "FCFA / an", cta: "Économiser 2 mois",
        items: ["Tout le plan Premium", "2 mois offerts par rapport au mensuel", "Un seul paiement par an"],
    },
];

export default function ViewPricing() {
    return (
        <section id="pricing" className="py-24 bg-[#f7f6fd]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <p className="text-sm font-bold tracking-wider text-brand-600 uppercase">Tarifs</p>
                    <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-950">Simple, et 3 mois offerts.</h2>
                    <p className="mt-4 text-slate-600">Chaque nouveau compte reçoit 3 mois de Premium. Ensuite, vous choisissez : sans engagement, sans renouvellement automatique.</p>
                </Reveal>

                <div className="mt-14 grid lg:grid-cols-3 gap-6 items-stretch">
                    {PLANS.map((p, i) => (
                        <Reveal key={p.name} delay={i * 90}>
                            <Tilt max={5} className={`h-full rounded-3xl p-8 flex flex-col ${p.featured
                                ? "text-white bg-gradient-to-br from-brand-500 via-brand-700 to-brand-900 shadow-[0_40px_80px_-30px_rgba(74,49,194,0.75)] lg:-translate-y-3"
                                : "bg-white border border-brand-100/70 shadow-[0_18px_40px_-28px_rgba(26,18,71,0.3)]"}`}>
                                <div className="flex items-center justify-between">
                                    <h3 className={`text-lg font-bold ${p.featured ? "" : "text-brand-950"}`}>{p.name}</h3>
                                    {p.featured && <span className="text-[11px] font-bold bg-amber-300 text-amber-950 rounded-full px-2.5 py-1">Le plus choisi</span>}
                                </div>
                                <p className="mt-6 flex items-baseline gap-2">
                                    <span className={`text-5xl font-extrabold tracking-tight tilt-pop ${p.featured ? "" : "text-brand-950"}`}>{p.price}</span>
                                    <span className={p.featured ? "text-white/70" : "text-slate-500"}>{p.period}</span>
                                </p>
                                <ul className="mt-8 space-y-3 flex-1">
                                    {p.items.map((it) => (
                                        <li key={it} className="flex items-start gap-3">
                                            <span className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${p.featured ? "bg-white/20" : "bg-brand-50 text-brand-600"}`}><Check className="w-3.5 h-3.5" /></span>
                                            <span className={p.featured ? "text-white/90" : "text-slate-700"}>{it}</span>
                                        </li>
                                    ))}
                                </ul>
                                <a href="#download" className={`mt-8 text-center font-bold py-3.5 rounded-xl transition-all hover:-translate-y-0.5 ${p.featured ? "bg-white text-brand-700" : "bg-brand-50 text-brand-700 hover:bg-brand-100"}`}>
                                    {p.cta}
                                </a>
                            </Tilt>
                        </Reveal>
                    ))}
                </div>

                <Reveal className="mt-10 flex flex-wrap justify-center gap-3 text-sm font-semibold text-slate-600">
                    <span className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 border border-brand-100/70"><Smartphone className="w-4 h-4 text-brand-500" /> Orange Money · Moov Money</span>
                    <span className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 border border-brand-100/70"><CreditCard className="w-4 h-4 text-brand-500" /> Carte bancaire</span>
                </Reveal>
            </div>
        </section>
    );
}
